const getters = {
    addRouters: state => state.permission.addRouters
}
export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js